// extracted by mini-css-extract-plugin
export default {"dashboard":"dashboard_dashboard__ukCVE","container":"dashboard_container__K05BF"};